import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "item", "folder"]

  connect() {
    this.captureStates()
  }

  captureStates() {
    if (this.hasFolderTarget) {
      this.folderStates = this.folderTargets.map(folder => folder.hasAttribute('open'))
    }
  }

  filter() {
    const query = this.inputTarget.value.toLowerCase().trim()

    if (query === "") {
      this.reset()
      return
    }

    if (this.hasFolderTarget && !this.folderStates) this.captureStates()

    // 1. Initially hide all folders and their summaries
    if (this.hasFolderTarget) {
      this.folderTargets.forEach(folder => {
        folder.classList.add("hidden")
        const summary = folder.querySelector('summary')
        if (summary) summary.classList.add('hidden')
        
        // Remove folder indentation/decoration for flat view
        const container = folder.querySelector('div.relative.before\\:absolute')
        if (container) {
          container.classList.remove('pl-7')
          container.classList.add('pl-1')
          container.classList.add('before:hidden')
        }
        folder.setAttribute('open', '') 
      })
    }

    // 2. Filter items and show their folders if they match
    this.itemTargets.forEach(item => {
      // Get text content and clean it up
      const text = item.textContent.replace(/\s+/g, ' ').trim().toLowerCase()
      
      if (text.includes(query)) {
        item.classList.remove("hidden")
        
        // Find if this item belongs to a folder
        let parent = item.parentElement
        while (parent && parent !== this.element) {
          if (parent.hasAttribute('data-side-search-target') && parent.getAttribute('data-side-search-target') === 'folder') {
            parent.classList.remove("hidden")
            break
          }
          parent = parent.parentElement
        }
      } else {
        item.classList.add("hidden")
      }
    })
  }

  reset() {
    this.itemTargets.forEach(item => item.classList.remove("hidden"))
    if (this.hasFolderTarget) {
      this.folderTargets.forEach((folder, index) => {
        folder.classList.remove("hidden")
        const summary = folder.querySelector('summary')
        if (summary) summary.classList.remove('hidden')
        
        const container = folder.querySelector('div.relative.before\\:absolute')
        if (container) {
          container.classList.add('pl-7')
          container.classList.remove('pl-1')
          container.classList.remove('before:hidden')
        }

        if (this.folderStates && this.folderStates[index]) {
          folder.setAttribute('open', '')
        } else {
          folder.removeAttribute('open')
        }
      })
    }
  }
}
